import bindEvent from '../../scripts/util/bindEvent';
import qsa from '../../scripts/util/DOM/qsa';
import qs from '../../scripts/util/DOM/qs';
import addClass from '../../scripts/util/DOM/addClass';
import vacansyForm from '../vacancy-form/vacancy-form';
import isElem from '../../scripts/util/isElement';
import TweenMax from 'TweenMax';
import Power2 from 'animation.gsap';
import {forEach} from 'ramda';
import $ from 'jquery';

const selectors = {
	card: '.js-vacancy-card',
	toggleButton: '.js-vacancy-card-toggle-button',
	form: '.vacancy-card__left',
	submit: '.vacancy-form',
	content: '.js-vacancy-content',
	rightBlock: '.vacancy-card__right',
	popup: '.vacancies__popup',
	button: '.vacancy-card__show',
	open: '.vacancy-card_open'
};

const classes = {
	hidden: 'vacancy-card_hidden',
	open: 'vacancy-card_open'
};

const texts = {
	hide: 'cвернуть',
	show: 'подробнее'
};

const cards = qsa(selectors.card);
const popup = qs(selectors.popup);

const setHeight = card => {
	const container = card.querySelector(selectors.content);
	TweenMax.set(container, {height: 'auto'});
	TweenMax.from(container, 0.3, {height: 0, ease: Power2.easeInOut});
};

const hideCard = card => {
	const container = card.querySelector(selectors.content);
	card.classList.remove(classes.open);
	addClass(classes.hidden)(card);
	TweenMax.to(container, 0.3, {height: 0, ease: Power2.easeInOut});
};

const showCard = card => {
	card.classList.remove(classes.hidden);
	setHeight(card);
	addClass(classes.open)(card);
};


const changeText = (card, text) => {
	const button = card.querySelector(selectors.button);
	button.innerHTML = text;
};

const closeCard = card => {
	hideCard(card);
	changeText(card, texts.show);
};

const openCard = card => {
	const activeCard = document.querySelector(`.${classes.open}`);
	if (activeCard) {
		closeCard(activeCard);
	}
	showCard(card);
	changeText(card, texts.hide);
};

const isHidden = card => {
	return card.classList.contains(classes.hidden);
};

const scrollToCard = card => () => {
	$('html, body').animate({
		scrollTop: $(card).offset().top - 70
	}, 500);
};

const toggleCard = e => {
	const card = e.currentTarget.closest(selectors.card);

	if (isHidden(card)) {
		openCard(card);
	} else {
		closeCard(card);
	}

	setTimeout(scrollToCard(card), 300);
};

const bindForm = card => {
	const form = card.querySelector(selectors.submit);
	vacansyForm(form);
};

const bindForms = () => {
	forEach(bindForm, cards);
	vacansyForm(popup);
};

const render = () => {
	if (isElem(selectors.card)) {
		bindEvent(selectors.form, 'click', e => e.stopPropagation());
		bindEvent(selectors.toggleButton, 'click', toggleCard);
		bindForms();
	}
};

export default render;
